import React from 'react';

// #region import componentes
import Skeleton from '../../atoms/Skeleton';
import CardContratantes from '../../molecules/CardContratantes';
import CollapseNestedList from '../CollapseNestedList';
import CounterContainer from './CounterContainer';
// #endregion

import { setParametrizacaoNivel } from '../../../utils/treeViewBuilder';

const ParametrizacaoCards = ({
  selectedCard,
  handleOnClickEditar,
  handleOnClickSalvar,
  idUsuario,
  handleToogleCard,
  handleModalCancelAction,
}) => {
  return (
    <CardContratantes
      marginTop="28px"
      contratanteHeader={
        selectedCard.cardLoading ? (
          <Skeleton height="13px" width="250px" marginUpDown="4" />
        ) : (
          setParametrizacaoNivel(selectedCard.tipoParametrizacao, selectedCard)
            .nome
        )
      }
      cardType={
        selectedCard.cardLoading ? (
          <Skeleton height="13px" width="200px" marginUpDown="4" />
        ) : (
          selectedCard.tipoParametrizacao
        )
      }
      display=""
      width="100%"
      onClickEditar={() => handleOnClickEditar(selectedCard.idCard)}
      onClickExcluir={() =>
        handleModalCancelAction(
          selectedCard.idCard,
          selectedCard.idParametrizacao
        )
      }
      onClickSalvar={
        idUsuario > 0
          ? () => handleOnClickSalvar(selectedCard)
          : () => handleToogleCard(selectedCard.idCard)
      }
      isEditar={selectedCard.isEditar}
      idUsuario={idUsuario}
      idParametrizacao={selectedCard.idParametrizacao}
      loading={selectedCard.nodeLoading}
    >
      {!selectedCard.isEditar ? (
        <CounterContainer
          response={selectedCard.contagem}
          loading={selectedCard.cardLoading}
        />
      ) : (
        <CollapseNestedList
          selectedOptions={selectedCard.selectedOptions}
          selectedCard={selectedCard}
          contagem={selectedCard.contagem}
          options={selectedCard.options}
          idUsuario={idUsuario}
        />
      )}
    </CardContratantes>
  );
};

export default ParametrizacaoCards;
